export interface UserStatusModel {
    userStatusId: number;
    name: string;
}

export const UserStatuses: UserStatusModel[] = [
    {
        userStatusId: 1,
        name: 'user_pending'
    },
    {
        userStatusId: 2,
        name: 'user_active'
    },
    {
        userStatusId: 3,
        name: 'user_blocked'
    },
    {
        userStatusId: 4,
        name: 'user_expired'
    },
]

export const UserStatusActionMessages: {[key: number]: string} = {
    1: 'make_pending',
    2: 'activate',
    3: 'block',
    4: 'make_expired',
}